import { createEventRoute } from 'utils/routes'
import GeneralSettings from './GeneralSettings'

export default {
    generalSettings: createEventRoute({
        title: 'portal_menu.general_settings',
        path: '/general-settings',
        component: GeneralSettings,
        exact: true,
        context: 'general-settings'
    }),

}
